import styled from 'styled-components';
import { colors } from '../../styles/stylesheets';

export const Badge = styled.span`
  border-radius: 12px;
  width: max-content;
  height: 20px;
  padding: 2px 8px 0px 8px;
  background-color:  ${({ color }) => (color || colors.white)}33 ;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};

  :hover{
    opacity: 0.8;
  }
`;

export const LabelText = styled.span`
  display: flex;
  align-items: center;
  margin: 0;
  white-space: nowrap;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 14px;
  color: ${({ color }) => color}; 
`;
